module.exports = __webpack_public_path__ + "media/entrance-ambience.a6ea1a18.mp3";